import { render, staticRenderFns } from "./ViParentOnlineTC.vue?vue&type=template&id=d1f965ea"
import script from "./ViParentOnlineTC.vue?vue&type=script&lang=js"
export * from "./ViParentOnlineTC.vue?vue&type=script&lang=js"
import style0 from "./ViParentOnlineTC.vue?vue&type=style&index=0&id=d1f965ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports